module.exports = __webpack_public_path__ + "static/media/logos_squares_Gold_SHK.9de990bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Gold_SHK.png
// module id = 87
// module chunks = 0